module.exports = __webpack_public_path__ + "static/media/logo-bookc.0ac6bd42.png";